import { createSlice } from '@reduxjs/toolkit';

const initialState = { failure: null, lastId: 0 };

const commandFailureSlice = createSlice({
  name: 'commandFailure',
  initialState,
  reducers: {
    commandFailed: {
      reducer: (state, action) => {
        state.lastId += 1;
        state.failure = { id: state.lastId, ...action.payload };
      },
      prepare: ({ system, device, macs, error }) => ({
        payload: {
          system: system.toLowerCase(),
          device,
          macs,
          reason: error?.message || 'unknown error',
        },
      }),
    },
    dismissCommandFailure: (state) => {
      state.failure = null;
    },
  },
});

export default commandFailureSlice;
export const selectCommandFailure = (state) => state.commandFailure.failure;
export const { commandFailed, dismissCommandFailure } =
  commandFailureSlice.actions;

const devicesLabel = (system, count) =>
  `${count} ${system.toLowerCase()} ${count === 1 ? 'device' : 'devices'}`;

export const reportMasterControlFailure =
  (dispatch, system, machineIds) => (error) =>
    dispatch(
      commandFailed({
        system,
        device: devicesLabel(system, machineIds.length),
        macs: machineIds,
        error,
      }),
    );
